import { render, staticRenderFns } from "./MaterialsCategories.vue?vue&type=template&id=59cad605&scoped=true"
import script from "./MaterialsCategories.vue?vue&type=script&lang=js"
export * from "./MaterialsCategories.vue?vue&type=script&lang=js"
import style0 from "./MaterialsCategories.vue?vue&type=style&index=0&id=59cad605&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cad605",
  null
  
)

export default component.exports